export enum RoomBookingErrors {
  INVALID_RATE_PLAN_TYPE = 'INVALID_RATE_PLAN_TYPE',
  RATE_PLAN_TYPE_UNAVAILABLE = 'RATE_PLAN_TYPE_UNAVAILABLE',
  PAYMENT_ATTEMPT_FAILED = 'PAYMENT_ATTEMPT_FAILED',
  REQUIRED_TERMS_CONSENT = 'REQUIRED_TERMS_CONSENT',
  ROOM_UNAVAILABLE = 'ROOM_UNAVAILABLE',
  CARD_NOT_FOUND = 'CARD_NOT_FOUND'
}

export enum RoomBookingStates {
  ACTIVE = 'ACTIVE',
  PENDING = 'PENDING',
  CANCELLED = 'CANCELLED',
  FAILED = 'FAILED'
}

export enum RoomBookingDepositPolicies {
  FULL = 'FULL',
  NONE = 'NONE',
  NUMBER_OF_NIGHTS = 'NUMBER_OF_NIGHTS',
  PERCENTAGE = 'PERCENTAGE'
}

export enum RatePlanIds { 
  FLEXIBLE = 'FLEXIBLE',
}